// Handler for mentioning users in comments
var UserMention =  {
    autocompleteTimer: undefined,
    lastMentionRegex: /@\b(\w+)$/,
    init: function() {
        $('.ii__mention-type').keyup(UserMention.findMention);
    },
    removeAutocomplete: function() {
        $('.comment__username-autocomplete').remove();
        window.removeEventListener('click', UserMention.removeAutocomplete, false);
    },
    getLastMention: function(text) {
        if ((typeof (text) === 'string') && (text.length > 0)) {
            var match = text.match(UserMention.lastMentionRegex);

            if (match) {
                return match[1];
            } else {
                return null;
            }
        } else {
            return null;
        }
    },
    findMention: function(e) {
        switch (e.keyCode) {
        case 38:
        case 40:
            UserMention.navList(e.keyCode);
            return false;
        case 13:
            UserMention.activeSelection();
            break;
        case 27:
            $('.comment__username-autocomplete').remove();
            break;
        default:
            UserMention.getCursorPosition(e);
            $('.comment__username-autocomplete').remove();
            clearTimeout(UserMention.autocompleteTimer);
            UserMention.autocompleteTimer = setTimeout(function() {
                let lastMention = UserMention.getLastMention($(e.target).val());
                if (lastMention) {
                    Ajax.autocompleteUsername(lastMention, (res) => {
                        UserMention.parseResponse(res, e.target);
                    });
                }
            }, 400);
        }
    },
    parseResponse: function(resp, target) {
        var usersData = [];
        if ((resp.success == 'ok') && resp.json) {
            usersData = resp.json;
        }
        UserMention.showAutoComplete(usersData, target);
    },
    showAutoComplete: function(usersData, target) {
        var parent = $(target).parent();

        $(parent).append(UserMention.buildAutoComplete(usersData));
        $('.ii__mention-username').on('click', UserMention.selectThis);
        window.addEventListener('click', UserMention.removeAutocomplete, false);
    },
    getCursorXY: function(input, selectionPoint) {
        var inputX = input.offsetLeft,
            inputY = input.offsetTop;
        // create a dummy element that will be a clone of our input
        var div = document.createElement('div');
        // get the computed style of the input and clone it onto the dummy element
        var copyStyle = getComputedStyle(input);
        Object.keys(copyStyle).forEach(function(prop) {
            div.style[prop] = copyStyle[prop];
        });
        // we need a character that will replace whitespace when filling our dummy element if it's a single line <input/>
        var swap = '.';
        var inputValue = input.tagName === 'INPUT' ? input.value.replace(/ /g, swap) : input.value;
        // set the div content to that of the textarea up until selection
        var textContent = inputValue.substr(0, selectionPoint);
        // set the text content of the dummy element div
        div.textContent = textContent;
        if (input.tagName === 'TEXTAREA') {
            div.style.height = 'auto';
        }
        // if a single line input then the div needs to be single line and not break out like a text area
        if (input.tagName === 'INPUT') {
            div.style.width = 'auto';
        }
        // create a marker element to obtain caret position
        var span = document.createElement('span');
        // give the span the textContent of remaining content so that the recreated dummy element is as close as possible
        span.textContent = inputValue.substr(selectionPoint) || '.';
        // append the span marker to the div
        div.appendChild(span);
        // append the dummy element to the body
        document.body.appendChild(div);
        // get the marker position, this is the caret position top and left relative to the input
        var spanX = span.offsetLeft,
            spanY = span.offsetTop;
        // lastly, remove that dummy element
        // NOTE:: can comment this out for debugging purposes if you want to see where that span is rendered
        document.body.removeChild(div);
        // return an object with the x and y of the caret. account for input positioning so that you don't need to wrap the input
        return {
            x: inputX + spanX,
            y: inputY + spanY,
        };
    },
    // target should be the event
    getCursorPosition: function(e) {
        var input = e.currentTarget;
        var offsetLeft    = input.offsetLeft,
            offsetTop     = input.offsetTop,
            offsetHeight  = input.offsetHeight,
            offsetWidth   = input.offsetWidth,
            scrollLeft    = input.scrollLeft,
            scrollTop     = input.scrollTop,
            selectionEnd  = input.selectionEnd;
        var newLinesMatch = $(e.target).val().match(/\n/g);
        var newLinesCount = newLinesMatch ? newLinesMatch.length : 0;
        // get style property values that we are interested in
        var computedStyle = getComputedStyle(input),
            lineHeight    = computedStyle.lineHeight,
            paddingRight  = computedStyle.paddingRight;
        // get the cursor X and Y from our helper function
        var xy = UserMention.getCursorXY(input, selectionEnd),
            x  = xy.x,
            y  = xy.y;
        // set the marker positioning
        // for the left positioning we ensure that the maximum left position is the width of the input minus the right padding using Math.min
        // we also account for current scroll position of the input
        var newLeft = Math.min(
            x - scrollLeft,
            (offsetLeft + offsetWidth) - parseInt(paddingRight, 10)
        );
        // for the top positioning we ensure that the maximum top position is the height of the input minus line height
        // we also account for current scroll position of the input
        var parsedLineHeight = parseInt(lineHeight, 10);
        var newTop = Math.min(
            y - scrollTop,
            (offsetTop + offsetHeight) - parsedLineHeight
        );

        UserMention.autocompletePositionStyle = 'left: ' + newLeft + 'px; bottom: ' + (newTop - (newLinesCount * parsedLineHeight)) + 'px;';
    },
    buildAutoComplete: function(usersData) {
        var listStyles = UserMention.autocompletePositionStyle ? ' style="' + UserMention.autocompletePositionStyle + '" ' : ' ',
            listItems = usersData.map(function(user) {
                return '\
                    <li style="cursor: pointer; font-weight: bold; margin-bottom: .3rem;" class="ii__mention-username"> \
                        ' + user.value + ' \
                    </li> \
                ';
            });

        return '<ul' + listStyles + 'class="comment__username-autocomplete">' + listItems.join('') + '</ul>';
    },
    selectThis: function(e) {
        try {
            var username = e.target ? $(e.target).text().trim() : e.textContent.trim(),
                fullText = $('.ii__mention-type').val().trim(),
                newFullText = UserMention.replaceLast(fullText, username);

            $('.ii__mention-type').val(newFullText);
            $('.comment__username-autocomplete').remove();
            window.removeEventListener('click', UserMention.removeAutocomplete, false);
            UserMention.autocompletePositionStyle = undefined;
        } catch (e) {
            console.error('ERROR: ', e);
        }
    },
    replaceLast: function(str, repVal) {
        // Regex matches last word starting with '@'.
        // Specifically:
        // str => 'man jon boy @girl woman' => will not replace anything
        // str => 'man jon boy @girl' => will replace '@girl'
        return str.replace(UserMention.lastMentionRegex, '@' + repVal );
    },
    getAutocompItems: function() {
        return $('.ii__mention-username');
    },
    getActiveItem: function() {
        return $('.ii__mention-username.active');
    },
    getActiveItemIndex: function() {
        if (UserMention.getActiveItem().length > 0) {
            return UserMention.getActiveItem().index();
        } else {
            return -1;
        }
    },
    navList: function(keyCode) {
        var activeIndex = UserMention.getActiveItemIndex(),
            list = UserMention.getAutocompItems(),
            max  = list.length;

        switch (keyCode) {
        case 38:
            UserMention.navUp(activeIndex, max);
            break;
        case 40:
            UserMention.navDown(activeIndex, max);
            break;
        default:
            return;
        }
    },
    navUp: function(activeIndex, maxIndex) {
        var newIndex;

        switch (activeIndex) {
        case -1:
            newIndex = maxIndex - 1;
            break;
        case 0:
            newIndex = maxIndex - 1;
        default:
            newIndex = activeIndex - 1;
        }
        UserMention.resetAutocompleteActive(newIndex);
    },
    navDown: function(activeIndex, maxIndex) {
        var newIndex = 0;

        if (activeIndex !== -1) {
            newIndex = (activeIndex + 1) % maxIndex;
        }

        UserMention.resetAutocompleteActive(newIndex);
    },
    resetAutocompleteActive: function(index) {
        try {
            var item = UserMention.getAutocompItems()[index];

            UserMention.getActiveItem().removeClass('active');
            $(item).addClass('active');

        } catch (e) {
            console.error('ERROR: ', e);
        }
    },
    activeSelection: function() {
        var activeItem = UserMention.getActiveItem();
        if (activeItem.length > 0) {
            UserMention.selectThis(activeItem[0]);
        }
    }
};
